import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import deletePersonaReducer from './delete/deletePersonaReducer';
import moveContactsReducer from './moveContactsReducer';
import personaLinkingReducer from './personaLinkingReducer';
import privateDLLoadingReducer from './distributionListLoadingReducer';
import favoritePickerReducer from './favoritePickerReducer';
import restoreContactsReducer from './delete/restoreContactsReducer';
import hardDeleteReducer from './delete/hardDeleteReducer';
import deletedItemsFolderReducer from './delete/deletedItemsFolderReducer';
import groupsReducer from './groups/groupsReducer';
import pdlEmailsPickerReducer from './pdlEmailsPickerReducer';

import type { HubViewState } from '../../state';

const reducer: Reducer<HubViewState> = combineReducers<HubViewState>({
    deletePersonaState: deletePersonaReducer,
    moveContactsState: moveContactsReducer,
    personaLinkingState: personaLinkingReducer,
    privateDLLoadingState: privateDLLoadingReducer,
    favoritePickerState: favoritePickerReducer,
    restoreContactsState: restoreContactsReducer,
    hardDeleteState: hardDeleteReducer,
    deletedItemsFolderState: deletedItemsFolderReducer,
    groupsState: groupsReducer,
    pdlEmailsPickerState: pdlEmailsPickerReducer,
} as ReducersMapObject<HubViewState>);

export default reducer;
